import { __rest, __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { DropdownIconButton } from '../../Dropdown/DropdownIconButton.js';
import { useMenuButton } from '../useMenuButton/useMenuButton.js';

var MenuIconButton = function (_a) {
    var _b = _a.look, look = _b === void 0 ? "tertiary" : _b; _a.sx; var _c = _a.themeKey, themeKey = _c === void 0 ? "menuIconButton" : _c, _d = _a.rounded, rounded = _d === void 0 ? true : _d, props = __rest(_a, ["look", "sx", "themeKey", "rounded"]);
    var menuButtonProps = useMenuButton().props;
    return (jsx(DropdownIconButton, __assign({ look: look, rounded: rounded, themeKey: themeKey }, menuButtonProps, props)));
};

export { MenuIconButton };
//# sourceMappingURL=MenuIconButton.js.map
